import request from '../../utils/request';

export const savePoiGroupService = (data, id = 0) => {
  const dataToSend = {
    data,
  };
  if (id > 0) {
    
    return async dispatch => {
      const response = await dispatch(
        request('/point-of-interest-groups/' + id, {
          method: 'PUT',
          data,
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    
    const response = await dispatch(
      request('/point-of-interest-groups', {
        method: 'POST',
        data,
      }),
    );
    return response;
  };
};

export const getPoiGroupsService = (params = null) => {
  if (params === null) {
    return async dispatch => {
      const response = await dispatch(
        request('/point-of-interest-groups', {
          method: 'GET',
        }),
      );
      return response;
    };
  }
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interest-groups', {
        method: 'GET',
        params,
      }),
    );
    return response;
  };
};

export const getPoiGroupsDropdownService = () => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interest-groups/dropdown', {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getPoiGroupByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interest-groups/' + id, {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const getPoiGroupCompleteByIdService = id => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interest-groups/' + id + '/complete', {
        method: 'GET',
      }),
    );
    return response;
  };
};

export const deletePoiGroupsService = array => {
  return async dispatch => {
    const response = await dispatch(
      request('/point-of-interest-groups', {
        method: 'DELETE',
        params: { idList: array },
      }),
    );
    
    return response;
  };
};
